import { useContext } from 'react';
import _find from 'lodash/find';
import _isArray from 'lodash/isArray';
import _isString from 'lodash/isString';
import _lowerCase from 'lodash/lowerCase';
import _toNumber from 'lodash/toNumber';
import _trim from 'lodash/trim';
import { AppContext, isValidJson, parseJSON } from 'commons-ui';

import { DATA_TYPES } from './helper';

const PICKER_VALUES: { id: string; keyType: string }[] = [
	{
		id: 'JSON',
		keyType: DATA_TYPES.JSON
	},
	{
		id: 'String',
		keyType: DATA_TYPES.STRING
	},
	{
		id: 'Number',
		keyType: DATA_TYPES.NUMBER
	},
	{
		id: 'Array',
		keyType: DATA_TYPES.ARRAY
	},
	{
		id: 'Boolean',
		keyType: DATA_TYPES.BOOLEAN
	},
	{
		id: 'Null',
		keyType: DATA_TYPES.NULL
	}
];
const useActualValueForKey = () => {
	const { showAlert } = useContext(AppContext);
	const getActualValue = (keyType: string, keyValue: string): any => {
		if (keyValue === undefined || (keyValue === '' && keyType !== DATA_TYPES.NULL)) {
			showAlert('Key Value is missing', { type: 'error' });
			return { actualKeyValue: undefined, error: true };
		}
		let actualKeyValue: any = _trim(keyValue);
		let error: boolean = false;
		switch (keyType) {
			case DATA_TYPES.JSON:
				if (isValidJson(actualKeyValue) && !_isArray(parseJSON(actualKeyValue))) {
					actualKeyValue = parseJSON(keyValue);
				} else {
					showAlert('The value is not a valid JSON', { type: 'error' });
					error = true;
				}
				break;
			case DATA_TYPES.ARRAY:
				if (isValidJson(actualKeyValue) && _isArray(parseJSON(actualKeyValue))) {
					actualKeyValue = parseJSON(actualKeyValue);
				} else {
					showAlert('The expression is not valid ARRAY', { type: 'error' });
					error = true;
				}
				break;
			case DATA_TYPES.STRING:
				if (_isString(parseJSON(keyValue))) {
					actualKeyValue = parseJSON(keyValue);
				} else {
					showAlert('Expected String but recieved something else', { type: 'error' });
					error = true;
				}
				break;
			case DATA_TYPES.NUMBER: {
				const convertedNum = +actualKeyValue;
				if (Number.isNaN(convertedNum)) {
					showAlert("Number is selected but didn't get it", { type: 'error' });
					error = true;
				} else if (convertedNum.toString() !== actualKeyValue) {
					showAlert('Number is either too big or too small to be stored as a number. Use String for such values', {
						type: 'error'
					});
					error = true;
				} else {
					actualKeyValue = _toNumber(actualKeyValue);
				}

				break;
			}
			case DATA_TYPES.BOOLEAN:
				if (_lowerCase(actualKeyValue) === 'true') {
					actualKeyValue = true;
				} else if (_lowerCase(actualKeyValue) === 'false') {
					actualKeyValue = false;
				} else {
					showAlert('Please enter valid boolean values', { type: 'error' });
					error = true;
				}

				break;
			case DATA_TYPES.NULL:
				actualKeyValue = null;
				break;
			default:
		}
		return { actualKeyValue, error };
	};

	const getTypeForValue = (value: any) => {
		let type: any;
		switch (typeof value) {
			case 'object':
				if (value === null) {
					type = DATA_TYPES.NULL;
				} else if (_isArray(value)) {
					type = DATA_TYPES.ARRAY;
				} else {
					type = DATA_TYPES.JSON;
				}
				break;
			case 'boolean':
				type = DATA_TYPES.BOOLEAN;
				break;
			case 'number':
				type = DATA_TYPES.NUMBER;
				break;
			case 'string':
				type = DATA_TYPES.STRING;
				break;
			default:
				type = DATA_TYPES.STRING;
		}
		return type;
	};

	const getPickerValueFromValueType = (type: string) => {
		const picker = _find(PICKER_VALUES, (pickerValue) => {
			if (pickerValue.keyType === type) {
				return true;
			}
			return false;
		});
		if (picker) {
			return [picker];
		}
		return [];
	};

	return {
		getActualValue,
		getTypeForValue,
		getPickerValueFromValueType,
		PICKER_VALUES
	};
};

export default useActualValueForKey;
